(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-blog-commerce"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pa-blog-commerce]');
    if (!roots.length) return;

    const pushEvent = (eventName, element, root) => {
      const payload = {
        event: eventName,
        article_handle: root.dataset.articleHandle || '',
        article_title: root.dataset.articleTitle || '',
        product_handle: element.dataset.productHandle || '',
        product_id: element.dataset.productId || '',
        variant_id: element.dataset.variantId || '',
        card_position: Number(element.dataset.cardPosition || 0),
        click_surface: element.dataset.clickSurface || '',
        availability: element.dataset.availability || '',
        price: Number(element.dataset.price || 0)
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `pa_article_origin=${encodeURIComponent(payload.article_handle)}; expires=${expires}; path=/; SameSite=Lax`;
      document.cookie = `pa_article_product=${encodeURIComponent(payload.product_handle)}; expires=${expires}; path=/; SameSite=Lax`;

      try {
        sessionStorage.setItem('pa_article_origin', JSON.stringify(payload));
      } catch (error) {
        return;
      }
    };

    roots.forEach((root) => {
      if (root.dataset.hideStaticCards === 'true') {
        const staticCards = document.querySelectorAll('.article__content .pa-shop');
        const firstStaticCard = staticCards[0];
        if (firstStaticCard && root.dataset.relocated !== 'true') {
          const movableSection = root.closest('.shopify-section') || root;
          firstStaticCard.before(movableSection);
          root.dataset.relocated = 'true';
        }
        staticCards.forEach((card) => {
          card.hidden = true;
        });
      }

      root.addEventListener('click', (event) => {
        const target = event.target.closest('[data-blog-product-click]');
        if (!target) return;
        pushEvent('blog_product_click', target, root);
      });

      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-blog-quick-add]');
        if (!form) return;
        pushEvent('blog_quick_add', form, root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-butcher-box-gwp-sync"]) return;
  try {
    
  (() => {
    const config = () => document.querySelector('[data-pa-bb-gwp-sync]');
    const money = (cents) => `$${(cents / 100).toFixed(2)}`;
    const cap = (text) => text ? text.charAt(0).toUpperCase() + text.slice(1) : text;

    const currentValues = (node) => ({
      enabled: node.dataset.enabled === 'true',
      tierOne: Number(node.dataset.tierOne) || 15000,
      tierTwo: Number(node.dataset.tierTwo) || 30000,
      shipping: Number(node.dataset.freeShipping) || 20000,
      giftOne: node.dataset.giftOne || '2 free Wagyu Beef Burger Patties 150g',
      giftTwo: node.dataset.giftTwo || 'a free Angus Rib Fillet SB 3 300g'
    });

    const installLandingCopy = (root, node, values) => {
      root.dataset.freeShip = String(values.shipping);
      root.dataset.giftMince = String(values.tierOne);
      root.dataset.giftWagyu = String(values.tierTwo);

      root.querySelectorAll('.pa-bb__promo-note:not([data-pa-gwp-current])').forEach((item) => item.remove());
      const promo = node.querySelector('[data-pa-bb-current-promo]');
      const actions = root.querySelector('.pa-bb__hero-actions');
      if (promo && actions) actions.insertAdjacentElement('afterend', promo);

      const trust = root.querySelector('.pa-bb__trust-row');
      if (trust) {
        [...trust.children].slice(1, 4).forEach((item) => item.remove());
        const labels = [`Free shipping over $${values.shipping / 100}`];
        if (values.enabled) labels.push(`Free gift over $${values.tierOne / 100}`, `Both gifts over $${values.tierTwo / 100}`);
        const reference = trust.children[1] || null;
        labels.forEach((label) => {
          const item = document.createElement('li');
          item.dataset.paGwpCurrent = '';
          item.textContent = label;
          trust.insertBefore(item, reference);
        });
      }

      const faq = root.querySelector('.pa-bb__faq-list');
      if (faq) {
        const rows = [...faq.querySelectorAll(':scope > details')];
        const obsolete = rows.filter((row) => {
          const question = row.querySelector('summary')?.textContent.trim().toLowerCase() || '';
          return question === 'do you offer free gifts with purchase?' || question === 'do you offer free shipping?';
        });
        const lastIndex = obsolete.reduce((max, row) => Math.max(max, rows.indexOf(row)), -1);
        const next = rows.find((row, index) => index > lastIndex && !obsolete.includes(row)) || null;
        obsolete.forEach((row) => row.remove());
        [...node.querySelectorAll('[data-pa-bb-current-faq] > details')].forEach((row) => faq.insertBefore(row, next));
      }
    };

    const installCardCopy = (root, values) => {
      root.querySelectorAll('.pa-bb__product-card').forEach((card) => {
        if (card.closest('.pa-bb__topups')) return;
        const actions = card.querySelector('.pa-bb__card-actions');
        const price = Number(card.dataset.paPriceCents) || 0;
        if (!actions || !price) return;

        card.querySelectorAll('.pa-bb__incentive').forEach((item) => item.remove());
        const messages = [];
        if (values.enabled) {
          if (price >= values.tierTwo) {
            messages.push(`Both gifts unlocked: ${values.giftOne} plus ${values.giftTwo}.`);
          } else if (price >= values.tierOne) {
            messages.push(`${cap(values.giftOne)} unlocked. Add ${money(values.tierTwo - price)} more to unlock both gifts.`);
          } else {
            messages.push(`Add ${money(values.tierOne - price)} more to get ${values.giftOne}.`);
          }
        }

        messages.forEach((message) => {
          const item = document.createElement('p');
          item.className = 'pa-bb__incentive';
          item.dataset.paGwpCurrent = '';
          item.textContent = message;
          actions.before(item);
        });

        if (price >= values.shipping) {
          const item = document.createElement('p');
          item.className = 'pa-bb__incentive pa-bb__incentive--secondary';
          item.dataset.paGwpCurrent = '';
          item.textContent = 'Free shipping unlocked.';
          actions.before(item);
        }
      });
    };

    const closeDrawer = (root) => {
      ['cart:close', 'drawer:close', 'cart-drawer:close'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
      document.documentElement.classList.remove('js-drawer-open', 'drawer-open');
      document.body.classList.remove('js-drawer-open', 'drawer-open', 'overflow-hidden', 'no-scroll');
      const selector = root.dataset.cartDrawer || '.drawer--cart, #CartDrawer, cart-drawer, .js-cart-drawer, [data-cart-drawer-el]';
      try {
        document.querySelectorAll(selector).forEach((drawer) => {
          drawer.classList.remove('is-open', 'drawer--is-open', 'active', 'is-visible', 'open');
          drawer.setAttribute('aria-hidden', 'true');
        });
      } catch (error) {
        // Ignore a merchant-entered selector that is not valid CSS.
      }
    };

    const showToast = (messages) => {
      let toast = document.getElementById('pa-bb-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'pa-bb-toast';
        toast.className = 'pa-bb__toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }

      const link = document.createElement('a');
      link.href = '/cart';
      link.textContent = 'View box';
      toast.replaceChildren(document.createTextNode(`${messages.join(' ')} `), link);
      toast.classList.add('is-visible');
      clearTimeout(window.__paBBGwpToastTimer);
      window.__paBBGwpToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 6000);
    };

    const buildMessages = (cart, values) => {
      const messages = ['Added to your box.'];
      if (values.enabled) {
        if (cart.total_price < values.tierOne) {
          messages.push(`Spend ${money(values.tierOne - cart.total_price)} more to get ${values.giftOne}.`);
        } else if (cart.total_price < values.tierTwo) {
          messages.push(`${cap(values.giftOne)} unlocked. Spend ${money(values.tierTwo - cart.total_price)} more to unlock both gifts, including ${values.giftTwo}.`);
        } else {
          messages.push(`Both gifts unlocked: ${values.giftOne} plus ${values.giftTwo}.`);
        }
      }
      messages.push(cart.total_price < values.shipping
        ? `You are ${money(values.shipping - cart.total_price)} from free shipping.`
        : 'Free shipping unlocked.');
      return messages;
    };

    const bindQuickAdd = () => {
      if (window.__paBBGwpQuickAddBound) return;
      window.__paBBGwpQuickAddBound = true;

      document.addEventListener('submit', async (event) => {
        const form = event.target.closest && event.target.closest('.pa-bb .pa-bb__add-form');
        if (!form) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.paLoading === 'true') return;

        const root = form.closest('.pa-bb');
        const button = form.querySelector('button[type="submit"]');
        const node = config();
        if (!root || !button || !node) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        }

        const values = currentValues(node);
        const originalLabel = button.textContent;
        form.dataset.paLoading = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding...';

        try {
          const shopRoot = window.Shopify?.routes?.root || '/';
          const addResponse = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!addResponse.ok) throw new Error('Unable to add item');

          const cartResponse = await fetch(`${shopRoot}cart.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!cartResponse.ok) throw new Error('Unable to read cart');
          const cart = await cartResponse.json();

          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble').forEach((item) => {
            item.textContent = String(cart.item_count);
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          button.textContent = 'Added';

          if ((root.dataset.cartBehaviour || 'toast') === 'drawer') {
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          } else {
            showToast(buildMessages(cart, values));
            closeDrawer(root);
          }

          setTimeout(() => {
            form.dataset.paLoading = 'false';
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = originalLabel;
          }, 1400);
        } catch (error) {
          form.dataset.paLoading = 'false';
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
          HTMLFormElement.prototype.submit.call(form);
        }
      }, true);
    };

    const initialize = () => {
      const node = config();
      const root = document.querySelector('.pa-bb');
      if (!node || !root || root.dataset.paGwpSynced === 'true') return;
      root.dataset.paGwpSynced = 'true';
      const values = currentValues(node);
      installLandingCopy(root, node, values);
      installCardCopy(root, values);
      bindQuickAdd();
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-butcher-box-landing-v3"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-pa-bbv3]');
  if (!root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sticky = root.querySelector('[data-sticky-cta]');
  const heroActions = root.querySelector('[data-hero-actions]');
  const closing = root.querySelector('.pa-bbv3__closing');
  const filterButtons = [...root.querySelectorAll('.pa-bbv3__filter')];
  const cards = [...root.querySelectorAll('[data-filter-grid] .pa-bbv3__product-card')];
  const status = root.querySelector('[data-filter-status]');
  const empty = root.querySelector('[data-filter-empty]');
  window.dataLayer = window.dataLayer || [];

  const scrollToTarget = (selector) => {
    const node = root.querySelector(selector);
    if (node) node.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
  };

  root.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href^="#"]');
    if (anchor) {
      const href = anchor.getAttribute('href');
      if (href && href.length > 1) {
        event.preventDefault();
        scrollToTarget(href);
      }
    }
    const tracked = event.target.closest('[data-pa-event]');
    if (tracked) {
      window.dataLayer.push({event:'pa_butcher_box_click',click_name:tracked.dataset.paEvent,product_title:tracked.dataset.paProductTitle,product_handle:tracked.dataset.paProductHandle,page_type:'butcher_box_landing_v3'});
    }
  });

  const applyFilter = (value) => {
    let shown = 0;
    cards.forEach((card) => {
      const categories = (card.dataset.paCategory || '').split(/\s+/);
      const visible = value === 'all' || categories.includes(value);
      card.hidden = !visible;
      if (visible) shown += 1;
    });
    filterButtons.forEach((button) => {
      const active = button.dataset.filter === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (status) status.textContent = `${shown} butcher box${shown === 1 ? '' : 'es'} shown.`;
    if (empty) empty.hidden = shown !== 0;
    scrollToTarget('#shop-boxes');
  };
  filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter)));

  if (sticky && heroActions && 'IntersectionObserver' in window) {
    let heroVisible = true;
    let closingVisible = false;
    const updateSticky = () => {
      const show = !heroVisible && !closingVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    new IntersectionObserver((entries) => { heroVisible = entries[0].isIntersecting; updateSticky(); }, {threshold:.1}).observe(heroActions);
    if (closing) new IntersectionObserver((entries) => { closingVisible = entries[0].isIntersecting; updateSticky(); }, {threshold:.05}).observe(closing);
  }

  const toast = root.querySelector('#pa-bbv3-toast');
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(window.__paBBV3Toast);
    window.__paBBV3Toast = setTimeout(() => toast.classList.remove('is-visible'), 5000);
  };

  root.addEventListener('submit', async (event) => {
    const form = event.target.closest('.pa-bbv3__add-form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.loading === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const original = button ? button.textContent : '';
    form.dataset.loading = 'true';
    if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); button.textContent = 'Adding…'; }
    try {
      const response = await fetch(root.dataset.cartAddUrl || '/cart/add', {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
      if (!response.ok) throw new Error('add_failed');
      const added = await response.json();
      const price = Number(button?.dataset.paProductPrice || 0);
      window.dataLayer.push({event:'add_to_cart',ecommerce:{currency:window.Shopify?.currency?.active || 'AUD',value:price,items:[{item_id:String(added.variant_id || added.id || button?.dataset.paVariantId || ''),item_name:button?.dataset.paProductTitle || added.product_title || '',item_variant:added.variant_title || '',price:price,quantity:added.quantity || 1}]}});
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      showToast('Added to your box. Review your cart when you are ready.');
      if (button) button.textContent = 'Added';
    } catch (error) {
      showToast('We could not add that item. Opening the standard cart flow.');
      form.submit();
      return;
    } finally {
      setTimeout(() => { form.dataset.loading = 'false'; if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; } }, 1200);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-butcher-box-landing-v4"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    const root = document.querySelector('[data-pa-bbv4]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileQuery = window.matchMedia('(max-width: 650px)');
    const grid = root.querySelector('[data-filter-grid]');
    const cards = grid ? [...grid.querySelectorAll('.pa-bbv4__product-card')] : [];
    const filterButtons = [...root.querySelectorAll('.pa-bbv4__filter')];
    const status = root.querySelector('[data-filter-status]');
    const empty = root.querySelector('[data-filter-empty]');
    const toast = root.querySelector('#pa-bbv4-toast');
    window.dataLayer = window.dataLayer || [];

    let activeFilter = 'all';
    let expanded = false;
    let controls = null;
    let revealButton = null;

    const pageSize = () => (mobileQuery.matches ? 8 : 12);
    const scrollToTarget = (selector) => {
      const node = root.querySelector(selector);
      if (node) node.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
    };

    /* ---------- single filter + paging renderer ---------- */
    const matchingCards = () => cards.filter((card) => {
      if (activeFilter === 'all') return true;
      return (card.dataset.paCategory || '').split(/\s+/).filter(Boolean).includes(activeFilter);
    });

    const renderGrid = ({announce = false, scroll = false} = {}) => {
      if (!grid || !cards.length) return;
      const matches = matchingCards();
      const limit = expanded ? matches.length : pageSize();
      const shown = Math.min(limit, matches.length);
      const remaining = Math.max(matches.length - shown, 0);

      cards.forEach((card) => { card.hidden = true; });
      matches.forEach((card, index) => { card.hidden = index >= limit; });

      if (empty) empty.hidden = matches.length !== 0;
      if (status && announce) {
        if (!matches.length) status.textContent = 'No butcher boxes match this filter.';
        else if (shown === matches.length) status.textContent = `${shown} butcher box${shown === 1 ? '' : 'es'} shown.`;
        else status.textContent = `Showing ${shown} of ${matches.length} butcher boxes.`;
      }
      if (controls && revealButton) {
        controls.hidden = matches.length <= pageSize();
        revealButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        revealButton.textContent = expanded ? 'Show fewer boxes' : `Show ${remaining} more box${remaining === 1 ? '' : 'es'}`;
      }
      if (scroll) scrollToTarget('#shop-boxes');
    };

    if (grid && cards.length) {
      controls = document.createElement('div');
      controls.className = 'pa-bbv4__reveal-controls';
      controls.hidden = true;
      revealButton = document.createElement('button');
      revealButton.type = 'button';
      revealButton.className = 'pa-bbv4__button pa-bbv4__button--more';
      revealButton.setAttribute('aria-controls', grid.id);
      revealButton.setAttribute('aria-expanded', 'false');
      revealButton.textContent = 'Show more boxes';
      controls.appendChild(revealButton);
      grid.insertAdjacentElement('afterend', controls);
      revealButton.addEventListener('click', () => {
        expanded = !expanded;
        renderGrid({announce: true, scroll: !expanded});
      });
      renderGrid();
    }

    filterButtons.forEach((button) => button.addEventListener('click', () => {
      activeFilter = button.dataset.filter || 'all';
      expanded = false;
      filterButtons.forEach((other) => {
        const isActive = other === button;
        other.classList.toggle('is-active', isActive);
        other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      renderGrid({announce: true, scroll: true});
    }));

    const breakpointChanged = () => { if (!expanded) renderGrid(); };
    if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', breakpointChanged);
    else if (typeof mobileQuery.addListener === 'function') mobileQuery.addListener(breakpointChanged);

    /* ---------- in-page anchors: scroll without writing a hash ---------- */
    root.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (anchor && root.contains(anchor)) {
        const href = anchor.getAttribute('href');
        if (href && href.length > 1) { event.preventDefault(); scrollToTarget(href); }
      }
      const tracked = event.target.closest('[data-pa-event]');
      if (tracked && root.contains(tracked)) {
        window.dataLayer.push({
          event: 'pa_butcher_box_click',
          click_name: tracked.dataset.paEvent,
          product_title: tracked.dataset.paProductTitle,
          product_handle: tracked.dataset.paProductHandle,
          page_type: 'butcher_box_landing_v4'
        });
      }
    });

    const showToast = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(window.__paBBV4Toast);
      window.__paBBV4Toast = setTimeout(() => toast.classList.remove('is-visible'), 6000);
    };

    /* ---------- cart ---------- */
    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('.pa-bbv4__add-form');
      if (!form) return;
      event.preventDefault();
      if (form.dataset.loading === 'true') return;

      const button = form.querySelector('button[type="submit"]');
      const labelEl = button ? button.querySelector('.pa-bbv4__add-label') : null;
      const original = labelEl ? labelEl.textContent : '';
      form.dataset.loading = 'true';
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (labelEl) labelEl.textContent = 'Adding…';

      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add', {
          method: 'POST', credentials: 'same-origin',
          headers: {Accept: 'application/json'}, body: new FormData(form)
        });
        if (!response.ok) throw new Error('add_failed');
        const added = await response.json();

        const price = Number(button?.dataset.paProductPrice || 0);
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
          event: 'add_to_cart',
          page_type: 'butcher_box_landing_v4',
          ecommerce: {
            currency: window.Shopify?.currency?.active || 'AUD',
            value: price,
            items: [{
              item_id: button?.dataset.paSku || button?.dataset.paProductId || '',
              item_name: button?.dataset.paProductTitle || added.product_title || '',
              item_variant: String(added.variant_id || button?.dataset.paVariantId || ''),
              item_category: (button?.dataset.paCategory || '').split(' ')[0],
              item_list_name: 'Butcher Box Landing V4',
              price: price,
              quantity: added.quantity || 1
            }]
          }
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        showToast('Added to your cart. Review it when you are ready.');
        if (labelEl) labelEl.textContent = 'Added';
      } catch (error) {
        showToast('We could not add that item. Opening the standard cart flow.');
        HTMLFormElement.prototype.submit.call(form);
        return;
      } finally {
        setTimeout(() => {
          form.dataset.loading = 'false';
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
          if (labelEl) labelEl.textContent = original;
        }, 1300);
      }
    });

    /* ---------- sticky CTA: hidden behind hero and at the closing band ---------- */
    const sticky = root.querySelector('[data-sticky-cta]');
    const stickyLink = sticky?.querySelector('a');
    const heroActions = root.querySelector('[data-hero-actions]');
    const closing = root.querySelector('.pa-bbv4__closing');

    if (sticky && stickyLink && heroActions && 'IntersectionObserver' in window) {
      let heroVisible = true;
      let closingVisible = false;

      const setStickyState = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        stickyLink.setAttribute('tabindex', visible ? '0' : '-1');
      };
      const updateSticky = () => {
        if (sticky.contains(document.activeElement)) return;
        setStickyState(!heroVisible && !closingVisible);
      };

      new IntersectionObserver((entries) => { heroVisible = entries[0].isIntersecting; updateSticky(); }, {threshold: .1}).observe(heroActions);
      if (closing) new IntersectionObserver((entries) => { closingVisible = entries[0].isIntersecting; updateSticky(); }, {threshold: .05}).observe(closing);

      sticky.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!sticky.contains(document.activeElement)) updateSticky();
        });
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-butcher-box-v3-ux-guard"]) return;
  try {
    
(() => {
  const boot = () => {
    const root = document.querySelector('[data-pa-bbv3]');
    if (!root || root.dataset.uxGuardBound === 'true') return;
    root.dataset.uxGuardBound = 'true';

    const grid = root.querySelector('[data-filter-grid]');
    const cards = grid ? [...grid.querySelectorAll('.pa-bbv3__product-card')] : [];
    const filterButtons = [...root.querySelectorAll('.pa-bbv3__filter')];
    const status = root.querySelector('[data-filter-status]');
    const empty = root.querySelector('[data-filter-empty]');
    const mobileQuery = window.matchMedia('(max-width: 650px)');
    const reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeFilter = filterButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.filter || 'all';
    let expanded = false;
    let controls = null;
    let revealButton = null;

    const pageSize = () => mobileQuery.matches ? 8 : 12;
    const cardMatchesFilter = (card) => {
      if (activeFilter === 'all') return true;
      const categories = (card.dataset.paCategory || '').split(/\s+/).filter(Boolean);
      return categories.includes(activeFilter);
    };
    const matchingCards = () => cards.filter(cardMatchesFilter);

    const scrollToGrid = () => {
      const section = root.querySelector('#shop-boxes');
      if (!section) return;
      section.scrollIntoView({behavior: reducedQuery.matches ? 'auto' : 'smooth', block: 'start'});
    };

    const renderGrid = ({announce = false, scroll = false} = {}) => {
      if (!grid || !cards.length) return;
      const matches = matchingCards();
      const limit = expanded ? matches.length : pageSize();
      const shown = Math.min(limit, matches.length);
      const remaining = Math.max(matches.length - shown, 0);

      cards.forEach((card) => { card.hidden = true; });
      matches.forEach((card, index) => { card.hidden = index >= limit; });

      if (empty) empty.hidden = matches.length !== 0;
      if (status && announce) {
        if (!matches.length) status.textContent = 'No butcher boxes match this filter.';
        else if (shown === matches.length) status.textContent = `${shown} butcher box${shown === 1 ? '' : 'es'} shown.`;
        else status.textContent = `Showing ${shown} of ${matches.length} butcher boxes.`;
      }

      if (controls && revealButton) {
        const needsControl = matches.length > pageSize();
        controls.hidden = !needsControl;
        revealButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        revealButton.textContent = expanded
          ? 'Show fewer boxes'
          : `Show ${remaining} more box${remaining === 1 ? '' : 'es'}`;
      }

      if (scroll) scrollToGrid();
    };

    if (grid && cards.length) {
      grid.id = grid.id || 'pa-bbv3-all-boxes-grid';
      controls = document.createElement('div');
      controls.className = 'pa-bbv3__reveal-controls';
      controls.dataset.revealControls = '';
      controls.hidden = true;
      revealButton = document.createElement('button');
      revealButton.type = 'button';
      revealButton.className = 'pa-bbv3__button pa-bbv3__button--more';
      revealButton.dataset.showMore = '';
      revealButton.setAttribute('aria-controls', grid.id);
      revealButton.setAttribute('aria-expanded', 'false');
      revealButton.textContent = 'Show more boxes';
      controls.appendChild(revealButton);
      grid.insertAdjacentElement('afterend', controls);

      revealButton.addEventListener('click', () => {
        expanded = !expanded;
        renderGrid({announce: true, scroll: !expanded});
      });

      renderGrid();
    }

    root.addEventListener('click', (event) => {
      const button = event.target.closest('.pa-bbv3__filter');
      if (!button || !root.contains(button)) return;
      window.setTimeout(() => {
        activeFilter = button.dataset.filter || 'all';
        expanded = false;
        filterButtons.forEach((filterButton) => {
          const isActive = filterButton === button;
          filterButton.classList.toggle('is-active', isActive);
          filterButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        renderGrid({announce: true});
      }, 0);
    });

    const breakpointChanged = () => {
      if (!expanded) renderGrid();
    };
    if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', breakpointChanged);
    else if (typeof mobileQuery.addListener === 'function') mobileQuery.addListener(breakpointChanged);

    const sticky = root.querySelector('[data-sticky-cta]');
    const stickyLink = sticky?.querySelector('a');
    const heroActions = root.querySelector('[data-hero-actions]');
    const closing = root.querySelector('.pa-bbv3__closing');

    if (sticky && stickyLink) {
      const setStickyState = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        const ariaValue = visible ? 'false' : 'true';
        const tabValue = visible ? '0' : '-1';
        if (sticky.getAttribute('aria-hidden') !== ariaValue) sticky.setAttribute('aria-hidden', ariaValue);
        if (stickyLink.getAttribute('tabindex') !== tabValue) stickyLink.setAttribute('tabindex', tabValue);
      };

      const isInViewport = (element) => {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      };

      const syncStickyAccessibility = () => {
        const hasFocus = sticky.contains(document.activeElement);
        const visuallyVisible = sticky.classList.contains('is-visible');
        setStickyState(hasFocus || visuallyVisible);
      };

      const stickyObserver = new MutationObserver(syncStickyAccessibility);
      stickyObserver.observe(sticky, {attributes: true, attributeFilter: ['class', 'aria-hidden']});
      sticky.addEventListener('focusin', syncStickyAccessibility);
      sticky.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (sticky.contains(document.activeElement)) return;
          const shouldShow = Boolean(heroActions) && !isInViewport(heroActions) && !isInViewport(closing);
          setStickyState(shouldShow);
        });
      });
      syncStickyAccessibility();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-intent-events"]) return;
  try {
    
  (() => {
    const intents = {
      '/collections/wagyu-steak-night': ['wagyu_intent_steak_night', 'Steak Night', 1],
      '/collections/wagyu-bbq-entertaining': ['wagyu_intent_bbq', 'BBQ and Entertaining', 2],
      '/collections/wagyu-low-and-slow': ['wagyu_intent_low_slow', 'Low and Slow', 3],
      '/collections/wagyu-whole-pieces': ['wagyu_intent_whole_pieces', 'Whole Pieces', 4],
      '/collections/wagyu-bulk-catering': ['wagyu_intent_bulk', 'Bulk and Catering', 5]
    };

    const syncGwp = () => {
      const node = document.querySelector('[data-paw-gwp-config]');
      if (!node) {
        document.documentElement.classList.add('pa-wagyu-gwp-ready');
        return;
      }
      try {
        const config = JSON.parse(node.textContent);
        document.querySelectorAll('.pa-wagyu-section .paw-promo').forEach((promo) => {
          const offer = promo.closest('.paw-offer');
          if (!config.enabled || !config.gift1) {
            if (offer) offer.remove();
            else promo.remove();
            return;
          }
          const spends = promo.querySelectorAll('.paw-promo__spend');
          const titles = promo.querySelectorAll('.paw-promo__title');
          const detail = promo.querySelector('.paw-promo__detail');
          const shipThreshold = promo.querySelector('.paw-promo__shipping strong');
          const shipLabel = promo.querySelector('.paw-promo__shipping span');
          if (spends[0]) spends[0].textContent = `Spend $${config.tier1}`;
          if (spends[1]) spends[1].textContent = `Spend $${config.tier2}`;
          if (titles[0]) titles[0].textContent = config.gift1;
          if (titles[1]) titles[1].textContent = 'Unlock both free gifts';
          if (detail) detail.textContent = config.gift2 ? `${config.gift1} plus ${config.gift2}` : config.gift1;
          if (shipThreshold) shipThreshold.textContent = `Orders over $${config.shipping}`;
          if (shipLabel) shipLabel.textContent = 'FREE shipping unlocked';
        });
      } catch (error) {
        // The Liquid-rendered promotion remains usable if parsing fails.
      }
      document.documentElement.classList.add('pa-wagyu-gwp-ready');
    };

    const bindIntentTracking = () => {
      if (window.__paWagyuIntentBound) return;
      window.__paWagyuIntentBound = true;
      document.addEventListener('click', (event) => {
        const link = event.target.closest && event.target.closest('a[href]');
        if (!link) return;
        let path;
        try {
          path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, '');
        } catch (error) {
          return;
        }
        const item = intents[path];
        if (!item) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: item[0], intent_label: item[1], tile_position: item[2],
          destination: path, source_page: window.location.pathname
        });
      }, true);
    };

    const addProgressiveDisclosure = (root, config) => {
      const grid = root.querySelector('#paw-grid .paw-picks');
      if (!grid || grid.dataset.progressive === 'true') return;
      const cards = [...grid.children].filter((item) => item.matches('.pawc'));
      if (!cards.length) return;
      grid.dataset.progressive = 'true';
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const firstBatch = Number(config.dataset[mobile ? 'mobile' : 'desktop']) || 8;
      const batchSize = Number(config.dataset.batch) || 8;
      let visibleCount = Math.min(firstBatch, cards.length);
      cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
      if (visibleCount === cards.length) return;
      if (!grid.id) grid.id = 'paw-wagyu-products';
      const wrapper = document.createElement('div');
      const button = document.createElement('button');
      const status = document.createElement('span');
      wrapper.className = 'paw-load-more';
      button.type = 'button';
      button.className = 'paw-load-more__button';
      button.setAttribute('aria-controls', grid.id);
      status.className = 'paw-load-more__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      wrapper.append(button, status);
      grid.after(wrapper);
      const update = () => {
        const remaining = cards.length - visibleCount;
        if (remaining < 1) {
          wrapper.remove();
          return;
        }
        button.textContent = `Show ${Math.min(batchSize, remaining)} more Wagyu cuts`;
        status.textContent = `${visibleCount} of ${cards.length} Wagyu cuts shown.`;
      };
      button.addEventListener('click', () => {
        const next = Math.min(cards.length, visibleCount + batchSize);
        for (let index = visibleCount; index < next; index += 1) cards[index].hidden = false;
        visibleCount = next;
        update();
      });
      update();
    };

    const limitBulkCards = (root, config) => {
      const limit = Number(config.dataset.bulk) || 4;
      root.querySelectorAll('#paw-bulk .paw-picks > .pawc').forEach((card, index) => {
        card.hidden = index >= limit;
      });
    };

    const manageStickyShortcut = (root) => {
      const bar = root.querySelector('.paw-sticky');
      const hero = root.querySelector('.paw-hero');
      const grid = root.querySelector('#paw-grid');
      if (!bar || !hero || !grid || bar.dataset.ready === 'true') return;
      bar.dataset.ready = 'true';
      bar.setAttribute('aria-hidden', 'true');
      let ticking = false;
      const update = () => {
        ticking = false;
        const y = window.scrollY || window.pageYOffset;
        const heroBottom = hero.getBoundingClientRect().bottom + y;
        const gridTop = grid.getBoundingClientRect().top + y;
        const visible = window.matchMedia('(max-width: 749px)').matches
          && y > heroBottom - 80
          && y + window.innerHeight * .72 < gridTop;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      update();
    };

    const initialize = () => {
      syncGwp();
      bindIntentTracking();
      const root = document.querySelector('.pa-wagyu-section .paw');
      const config = document.querySelector('[data-paw-ux]');
      if (!root || !config) return;
      addProgressiveDisclosure(root, config);
      limitBulkCards(root, config);
      manageStickyShortcut(root);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-pure-wagyu-ux"] && !Shopify.designMode) return;
  try {
    
(() => {
const CONFIG_SELECTOR = '[data-paw-pure-ux]';
const MOBILE_QUERY = '(max-width: 749px)';
const normalizedPath = (href) => {
try {
return new URL(href, window.location.origin).pathname.replace(/\/$/, '');
} catch (error) {
return href || '';
}
};
const collectPicksBeforeGrid = (root, gridSection) => {
const paths = new Set();
for (const child of root.children) {
if (child === gridSection) break;
child.querySelectorAll?.('.paw-picks .pawc__title[href]').forEach((link) => {
paths.add(normalizedPath(link.getAttribute('href')));
});
}
return paths;
};
const removeRepeatedProducts = (root, gridSection, grid) => {
const picks = collectPicksBeforeGrid(root, gridSection);
if (!picks.size) return 0;
let removed = 0;
grid.querySelectorAll(':scope > .pawc').forEach((card) => {
const link = card.querySelector('.pawc__title[href]');
if (!link || !picks.has(normalizedPath(link.getAttribute('href')))) return;
card.dataset.pawDuplicate = '';
card.hidden = true;
removed += 1;
});
if (removed && !gridSection.querySelector('[data-paw-grid-note]')) {
const note = document.createElement('p');
note.className = 'paw-pure-grid-note';
note.dataset.pawGridNote = '';
note.textContent = "Butcher's Picks are shown above and are not repeated here.";
const heading = gridSection.querySelector('.paw-head');
if (heading) heading.insertAdjacentElement('afterend', note);
}
return removed;
};
const progressiveGrid = (root, config) => {
const gridSection = root.querySelector('#paw-grid');
const grid = gridSection?.querySelector('.paw-picks');
if (!gridSection || !grid || grid.dataset.pawProgressive === 'true') return;
grid.dataset.pawProgressive = 'true';
if (config.dataset.hideDuplicatePicks === 'true') {
removeRepeatedProducts(root, gridSection, grid);
}
const cards = [...grid.querySelectorAll(':scope > .pawc')]
.filter((card) => !card.hasAttribute('data-paw-duplicate'));
if (!cards.length) return;
const media = window.matchMedia(MOBILE_QUERY);
const initialMobile = Number(config.dataset.initialMobile) || 8;
const initialDesktop = Number(config.dataset.initialDesktop) || 12;
const batch = Number(config.dataset.batchSize) || 8;
let shown = Math.min(media.matches ? initialMobile : initialDesktop, cards.length);
const reveal = () => {
cards.forEach((card, index) => {
card.hidden = index >= shown;
});
};
reveal();
if (shown >= cards.length) return;
if (!grid.id) grid.id = 'paw-pure-product-grid';
const wrapper = document.createElement('div');
const button = document.createElement('button');
const status = document.createElement('span');
wrapper.className = 'paw-pure-load-more';
wrapper.dataset.pawLoadMore = '';
button.type = 'button';
button.className = 'paw-pure-load-more__button';
button.setAttribute('aria-controls', grid.id);
status.className = 'paw-pure-load-more__status';
status.setAttribute('role', 'status');
status.setAttribute('aria-live', 'polite');
wrapper.append(button, status);
grid.insertAdjacentElement('afterend', wrapper);
const update = () => {
const remaining = cards.length - shown;
status.textContent = `${shown} of ${cards.length} Pure Wagyu cuts shown.`;
if (remaining < 1) {
wrapper.remove();
return;
}
button.textContent = `Show ${Math.min(batch, remaining)} more Pure Wagyu cuts`;
};
button.addEventListener('click', () => {
if (button.disabled) return;
button.disabled = true;
shown = Math.min(cards.length, shown + batch);
reveal();
update();
window.requestAnimationFrame(() => {
button.disabled = false;
});
});
const ensureModeMinimum = () => {
const minimum = media.matches ? initialMobile : initialDesktop;
if (shown < minimum) {
shown = Math.min(cards.length, minimum);
reveal();
update();
}
};
media.addEventListener?.('change', ensureModeMinimum);
update();
};
const smartSticky = (root, config) => {
const sticky = root.querySelector('.paw-sticky');
const hero = root.querySelector('.paw-hero');
const grid = root.querySelector('#paw-grid');
if (!sticky || !hero || !grid || sticky.dataset.pawSmartReady === 'true') return;
sticky.dataset.pawSmartReady = 'true';
sticky.setAttribute('aria-hidden', 'true');
const media = window.matchMedia(MOBILE_QUERY);
const smart = config.dataset.smartSticky === 'true';
const update = () => {
const heroPassed = hero.getBoundingClientRect().bottom < 80;
const gridAhead = grid.getBoundingClientRect().top > window.innerHeight * .68;
const visible = media.matches && (smart ? heroPassed && gridAhead : true);
sticky.classList.toggle('is-visible', visible);
sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
};
if ('IntersectionObserver' in window) {
const observer = new IntersectionObserver(update, {
rootMargin: '-80px 0px -25% 0px',
threshold: [0, .01]
});
observer.observe(hero);
observer.observe(grid);
}
media.addEventListener?.('change', update);
window.addEventListener('resize', update, { passive: true });
update();
};
const initialize = () => {
const config = document.querySelector(CONFIG_SELECTOR);
const root = document.querySelector('.pa-pure-wagyu-section .paw');
if (!config || !root || root.dataset.pawUxReady === 'true') return;
root.dataset.pawUxReady = 'true';
root.dataset.pawCompactMobile = config.dataset.compactMobile;
progressiveGrid(root, config);
smartSticky(root, config);
};
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
initialize();
}
document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
